<template>
  <div
    class="flex w-full justify-start rounded-t-lg bg-background"
  >
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      :class="[
        tab.value === modelValue
          ? 'border-primary text-primary'
          : 'border-transparent text-background-fg/50 hover:border-background-fg/70 hover:text-background-fg/70',
        'whitespace-nowrap border-b-2 p-4 text-sm font-semibold',
      ]"
      @click="modelValue = tab.value"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup lang="ts" generic="TValue extends string">
export type TabOption<TV extends string> = {
  value: TV
  label: string
}

defineProps<{
  tabs: Array<TabOption<TValue>>
}>()

const modelValue = defineModel<TValue>({ required: true })
</script>
